export enum AlertType {
  Success = "success",
  Info = "info",
  Warning = "warning",
  Danger = "danger",
}
